import React from "react";
import ActionButton from "../components/layout/actionButtons";
import Search from "../components/general/search";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Button } from "@material-ui/core";
import Settings from "../components/accounting/settings"
import ProjectService from '../services/projects';
import ProjectList from '../components/projects/projectlist';
import ConceptInvoice from '../components/accounting/conceptinvoice';
import ClientService from '../services/clients';
import WorkorderitemService from '../services/workorderitems';
import SettingsService from '../services/settings';
import SyncClients from "../components/visma/syncclients";
import SyncProjects from "../components/visma/syncprojects";

class Accounting extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selectedTab: 0, projects: [], filteredProjects: [], project: {}, client: {}, orderitems: [], settings: {} };
  }


  componentDidMount() {
    
    if (!this.props.match.params.id) {
      const vismaLogin = <Button color="primary" variant="contained" onClick={() => { this.props.history.push('/visma') }}>Inloggen visma</Button>
      this.props.handleMenu(
        {
          title: 'Boekhouding',
          handleActions: <ActionButton {...this.props} itemleft={vismaLogin} ></ActionButton>,

        })
      this.getListProjects();
    } else {

      this.props.handleMenu(
        {
          title: 'Boekhouding - project',
          showBackButton: true,
          handleActions: <ActionButton {...this.props} handleSave={this.handleSave}></ActionButton>
        })

      this.getProject(this.props.match.params.id);

      WorkorderitemService.getByProjectID(this.props.match.params.id).then(
        (orderitems) => {
          orderitems = orderitems.filter((item) => { return item.status === 3 })
          this.setState({ orderitems });
        },
        (error) => {

        })
    }
    this.getSettings();
  }

  compareProject(a, b) {
    if (a.name < b.name)
      return -1;
    if (a.name > b.name)
      return 1;
    return 0;
  }

  compareProjectNr(a, b) {
    if (a.projectnumber > b.projectnumber)
      return -1;
    if (a.projectnumber < b.projectnumber)
      return 1;
    return 0;
  }

  getListProjects() {
    ProjectService.get().then(
      (projects) => {
        projects.sort(this.compareProjectNr)
        this.setState({ projects, filteredProjects: projects })
      },
      (error) => { }
    )
  }

  getSettings() {

    SettingsService.get().then(
      (settings) => {
        this.setState({ settings });
      }, (err) => { });

  }

  getProject(id) {
    ProjectService.get(id).then(
      (project) => {
        this.setState({ project });
        ClientService.get(project.client._id).then(
          (client) => {
            this.setState({ client });
          },
          (error) => { }
        )
      },
      (error) => {

      }
    )
  }


  handleSearch = (search) => {
    let filteredProjects = this.state.projects;
    filteredProjects = filteredProjects.filter((item) => { return (JSON.stringify(item).toLowerCase().indexOf(search.toLowerCase()) >= 0) });
    this.setState({ filteredProjects });
  }
  handleChangeStatusTab = (event, value) => {
    this.setState({ selectedTab: value })
  }

  handleProjectClick = (project) => {
    if(project.client && project.type){
      this.props.history.push('/accounting/' + project._id)
    }else{
      this.props.handleMessage({ title: "Kan dit project niet openen. Klant of Type ontbreekt." });
    }
  }

  handleUpdateSettings = (settings) => {
    this.setState({ settings });
    SettingsService.save(settings);
    if (!settings._id) {
      this.getSettings();
    }
  }
  handleUpdateOrderItem = (item) => {
    let orderitems = Object.assign([], this.state.orderitems);
    this.setState({ orderitems });
  }

  handleUpdateOrderItems = (items) => {
    WorkorderitemService.saveItems(items, false);
    this.setState({ items });
    this.props.history.push('/accounting');
  }

  render() {

    return (
      <div>
        {
          !this.props.match.params.id
          &&
          <AppBar position="static" color="secondary">
            <Tabs value={this.state.selectedTab} onChange={this.handleChangeStatusTab}>
              <Tab label="Projecten" />
              <Tab label="Synchroniseer debiteuren" />
              <Tab label="Synchroniseer projecten" />
              <Tab label="Instellingen" />
            </Tabs>
          </AppBar>
        }

        {(this.state.selectedTab === 0 && !this.props.match.params.id)
          &&
          <React.Fragment>
            <Search handleSearch={this.handleSearch} placeholder="Zoek naar project" />
            <ProjectList items={this.state.filteredProjects} handleClick={this.handleProjectClick} />
          </React.Fragment>
        }

        {(this.state.selectedTab === 1 && !this.props.match.params.id)
          &&
          <SyncClients {...this.props}></SyncClients>

        }
        {(this.state.selectedTab === 2 && !this.props.match.params.id)
          &&
          <SyncProjects {...this.props}></SyncProjects>

        }
        {this.props.match.params.id
          &&
          <ConceptInvoice orderitems={this.state.orderitems} project={this.state.project} updateOrderItems={this.handleUpdateOrderItems} client={this.state.client} settings={this.state.settings} updateOrderItem={this.handleUpdateOrderItem} {...this.props}/>
        }

        {(this.state.selectedTab === 3 && !this.props.match.params.id)
          &&
          <Settings settings={this.state.settings} handleUpdate={this.handleUpdateSettings} />
        }
      </div >
    )
  }
}

export default Accounting;